<template>
  <div>
    <div v-for="(section,s) in page.sections" :key="s">
      <section-header v-if="section.type==='header'" v-model="section.data"></section-header>
      <section-about v-if="section.type==='about'" v-model="section.data"></section-about>
      <section-features v-if="section.type==='features'" v-model="section.data"></section-features>
      <section-services v-if="section.type==='services'" v-model="section.data"></section-services>
      <section-previews v-if="section.type==='previews'" v-model="section.data"></section-previews>
      <section-video v-if="section.type==='video'" v-model="section.data"></section-video>
      <section-divider v-if="section.type==='divider'" v-model="section.data"></section-divider>
      <section-pricing v-if="section.type==='pricing'" v-model="section.data"></section-pricing>
    </div>
  </div>
</template>

<script>
import About from "@/components/page/About";
import Features from "@/components/page/Features";
import Services from "@/components/page/Services";
import Previews from "@/components/page/Previews";
import Video from "@/components/page/Video";
import Header from "@/components/page/Header";
import Divider from "@/components/page/Divider";
import Pricing from "@/components/page/Pricing";
export default {
  props: ["value"],
  name: "PagePreview",
  components: {
    sectionAbout: About,
    sectionFeatures: Features,
    sectionServices: Services,
    sectionPreviews: Previews,
    sectionVideo: Video,
    sectionHeader: Header,
    sectionDivider: Divider,
    sectionPricing: Pricing
  },
  computed: {
    page() {
      return this.value;
    }
  },
  created() {
    console.log("this.$route.hash", this.$route.hash);
    setTimeout(
      function() {
        if (this.$route.hash) {
          this.$vuetify.goTo(this.$route.hash, {
            offset: this.$vuetify.breakpoint.name === "xs" ? 54 : 75
          });
        }
      }.bind(this),
      500
    );
  }
};
</script>

<style>
</style>